'use client';

import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';

import { Box, Paper, Typography } from '@mui/material';

import { Markdown } from '../../../../../../components/markdown/Markdown';
import { Button } from '../../../../../../components/button/Button';

export const PageSelector = () => {
  const t = useTranslations();
  const router = useRouter();

  return (
    <Paper sx={{ p: { xs: 2, md: 4 }, height: '100%' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">{t('headers.pageSelectorReportHeader')}</Typography>
        <Markdown>{t('text.pageSelectorReportDesc')}</Markdown>
      </Box>

      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
        <Button
          size="large"
          handleClick={() => {
            router.push('report');
          }}
        >
          {t('labels.report')}
        </Button>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">{t('headers.pageSelectorCheckReportHeader')}</Typography>
        <Markdown>{t('text.pageSelectorCheckReportDesc')}</Markdown>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          size="large"
          handleClick={() => {
            router.push('check-report');
          }}
        >
          {t('labels.checkReport')}
        </Button>
      </Box>
    </Paper>
  );
};
